export type Language = 'en' | 'fr';

export const dictionary: Record<Language, Record<string, string>> = {
  en: {
    'nav.dashboard': 'Dashboard',
    'nav.inventory': 'Inventory',
    'nav.requisitions': 'Requisitions',
    'nav.connections': 'Connections',
    'nav.geoMap': 'Geo Map',
    'nav.navigation': 'Navigation',
    'nav.collapse': 'Collapse',
    'nav.contracts': 'Contracts',
    'nav.mobile': 'Field App',

    'header.search': 'Search requisitions, materials...',
    'header.notifications': 'Notifications',
    'header.language': 'Language',

    'page.dashboardTitle': 'Overview Dashboard',
    'page.dashboardSub': 'materials and connections, live mode',
    'page.inventoryTitle': 'Inventory Management',
    'page.inventorySub': 'Line materials across all warehouses',
    'page.requisitionsTitle': 'Requisition Pipeline',
    'page.requisitionsSub': 'Sign-off workflow from consultant review to stock release',
    'page.connectionsTitle': 'Electrification Dashboard',
    'page.connectionsSub': 'Programme tracking across West Africa',
    'page.geoMapTitle': 'GIS Web Map Application',
    'page.geoMapSub': 'Geospatial layers for',

    'kpi.totalMaterials': 'Total Line Materials',
    'kpi.activeRequisitions': 'Active Requisitions',
    'kpi.pendingApprovals': 'Pending CD Approvals',
    'kpi.trackedConnections': 'Tracked Connections',
    'kpi.deltaQuarter': '3.2% vs last quarter',
    'kpi.deltaFewer': '8 fewer than last week',
    'kpi.deltaUrgent': 'Urgent, action required',
    'kpi.deltaThisMonth': 'this month',
    'kpi.urgentBadge': 'URGENT',

    'status.in_stock': 'In Stock',
    'status.low_stock': 'Low Stock',
    'status.out_of_stock': 'Out of Stock',
    'status.pending_approval': 'Pending Approval',
    'status.director_approved': 'Director Approved',
    'status.released': 'Released',

    'priority.urgent': 'Urgent',
    'priority.high': 'High',
    'priority.normal': 'Normal',
    'priority.low': 'Low',

    'stage.consultant_review': 'Consultant Review',
    'stage.signed_hardcopy': 'Signed Hardcopy',
    'stage.chief_director_approval': 'Chief Director Approval',
    'stage.main_stock_release': 'Main Stock Release',
    'stage.short.consultant_review': 'Review',
    'stage.short.signed_hardcopy': 'Hardcopy',
    'stage.short.chief_director_approval': 'CD Approval',
    'stage.short.main_stock_release': 'Released',

    'table.itemCode': 'Item Code',
    'table.description': 'Description',
    'table.category': 'Category',
    'table.warehouse': 'Warehouse',
    'table.quantity': 'Quantity',
    'table.unit': 'Unit',
    'table.reorderLevel': 'Reorder Level',
    'table.status': 'Status',
    'table.lastUpdated': 'Last Updated',
    'table.requisitionId': 'Requisition ID',
    'table.contractor': 'Contractor',
    'table.department': 'Department',
    'table.region': 'Region',
    'table.item': 'Item',
    'table.qtyRequested': 'Qty Requested',
    'table.stage': 'Stage',
    'table.priority': 'Priority',
    'table.hardcopyRef': 'Hardcopy Ref',
    'table.submitted': 'Submitted',
    'table.approved': 'Approved',
    'table.releasedDate': 'Released',
    'table.country': 'Country',
    'table.program': 'Programme',
    'table.utility': 'Utility',
    'table.accessPercent': 'Access %',
    'table.progressToTarget': 'Progress to Target',
    'table.households': 'Tracked Households',
    'table.newThisMonth': 'New This Month',

    'filter.allWarehouses': 'All Warehouses',
    'filter.allStatus': 'All Status',
    'filter.allStages': 'All Stages',
    'filter.allPriorities': 'All Priorities',

    'action.export': 'Export',
    'action.viewAll': 'View all',
    'action.requestAccess': 'Request Map Access',
    'action.live': 'Live',
    'action.lastRefreshed': 'Data last refreshed',

    'section.recentRequisitions': 'Recent Requisitions',
    'section.recentRequisitionsSub': 'Latest 5 requisitions across all warehouses',
    'section.waepAccess': 'Electrification Access',
    'section.waepAccessSub': 'Access % vs 100% target by country',
    'section.monthlyRollout': 'Monthly Connection Rollout',
    'section.monthlyRolloutSub': 'New connections per month vs cumulative total',
    'section.countrySummary': 'Country Programme Summary',

    'common.Units': 'Units',
    'common.Metres': 'Metres',
    'common.Sets': 'Sets',
    'common.noResults': 'No results found',
    'common.showing': 'Showing',
    'common.of': 'of',
    'common.results': 'results',
    'common.urgentPending': 'urgent requisitions awaiting Chief Director approval',

    'category.Transformers': 'Transformers',
    'category.Cables': 'Cables',
    'category.Meters': 'Meters',
    'category.Conductors': 'Conductors',
    'category.Grounding': 'Grounding',

    'material.DT-100KVA': 'Distribution Transformer 100 KVA',
    'material.DT-315KVA': 'Distribution Transformer 315 KVA',
    'material.DT-500KVA': 'Distribution Transformer 500 KVA',
    'material.LVC-25MM': 'LV Cable 25mm2 Armoured',
    'material.LVC-70MM': 'LV Cable 70mm2 Armoured',
    'material.PPM-STS': 'Prepaid Meter STS Single Phase',
    'material.PPM-3PH': 'Prepaid Meter 3-Phase Commercial',
    'material.ACSR-Dog': 'ACSR Dog Conductor',
    'material.ACSR-Rabbit': 'ACSR Rabbit Conductor',
    'material.GRD-ROD-16': 'Grounding Rod 16mm Copper Clad',
    'material.GRD-ROD-20': 'Grounding Rod 20mm Copper Clad',
    'material.SVC-DROP': 'Service Drop Cable 16mm2',

    'map.heatmap': 'PEPT Electrification Heatmap',
    'map.heatmapSub': 'Density-weighted view of household connection rates by district',
    'map.facilities': 'Unelectrified Schools and Hospitals',
    'map.facilitiesSub': 'Point layer of public facilities without grid connection',
    'map.substations': 'Grid Substations and Infrastructure',
    'map.substationsSub': '33kV and 11kV substations, transmission corridors, feeder routes',
    'map.fieldSites': 'Contractor Field Sites',
    'map.fieldSitesSub': 'Active project sites linked to requisitions',
    'map.boundaries': 'Administrative Boundaries',
    'map.boundariesSub': 'Member state boundaries, districts, and utility franchise zones',
    'map.ready': 'Layer Ready',
    'map.inDevelopment': 'In Development',
    'map.planned': 'Planned',
    'map.comingSoon': 'Interactive Map Coming Soon',

    'toast.countrySwitched': 'Switched to {name}, {utility}',
    'toast.languageSwitched': 'Interface language set to English',
    'toast.exported': 'Export started',

    'nav.reconciliation': 'Reconciliation',
    'page.reconTitle': 'Material Reconciliation',
    'page.reconSub': 'Materials released against connections observed',
    'recon.materialsReleased': 'Materials Released',
    'recon.expected': 'Expected Connections',
    'recon.observed': 'Observed Connections',
    'recon.verified': 'Verified',
    'recon.netVariance': 'Net Variance',
    'recon.variance': 'Variance',
    'recon.confidence': 'Confidence',
    'recon.releasedUnits': 'Released Units',
    'recon.connections': 'Connections',
    'recon.modelControls': 'Model Controls',
    'recon.perUnit': 'connections per unit',
    'recon.commissioningLag': 'Commissioning Lag',
    'recon.days': 'days',
    'recon.resetDefaults': 'Reset to defaults',
    'recon.inFlight': 'releases still within the lag window',
    'recon.holdApplied': 'Approval hold applied',
    'recon.holdBanner': 'contractors on approval hold',
    'recon.onHold': 'On hold',
    'recon.noFlags': 'No contractors outside tolerance',
    'recon.blendMath': 'How this estimate was built',
    'recon.lineItems': 'Qualifying releases',
    'recon.ratioApplied': 'Ratio',
    'recon.contribution': 'Contribution',
    'status.on_track': 'On Track',
    'status.watch': 'Watch',
    'status.investigate': 'Investigate',
    'status.over_reported': 'Over-Reported',
    'confidence.high': 'High',
    'confidence.medium': 'Medium',
    'confidence.low': 'Low',

    'mtf.viewRate': 'Connection Rate',
    'mtf.viewTier': 'Access Tier',
    'mtf.rateSub': 'Current access % vs 100% universal target',
    'mtf.tierSub': 'Share of population by service tier, Tier 0 to Tier 5',
    'mtf.disclaimer': 'Adapted from the World Bank ESMAP Multi-Tier Framework, simplified for this view',
    'tier.0': 'No Access',
    'tier.1': 'Very Limited',
    'tier.2': 'Limited',
    'tier.3': 'Moderate',
    'tier.4': 'High',
    'tier.5': 'Very High',
    'attribute.capacity': 'Capacity',
    'attribute.duration': 'Duration',
    'attribute.reliability': 'Reliability',
    'attribute.affordability': 'Affordability',
    'table.modalTier': 'Typical Tier',
  },
  fr: {
    'nav.dashboard': 'Tableau de bord',
    'nav.inventory': 'Inventaire',
    'nav.requisitions': 'Réquisitions',
    'nav.connections': 'Connexions',
    'nav.geoMap': 'Carte SIG',
    'nav.navigation': 'Navigation',
    'nav.collapse': 'Réduire',
    'nav.contracts': 'Contrats',
    'nav.mobile': 'App Terrain',

    'header.search': 'Rechercher réquisitions, matériels...',
    'header.notifications': 'Notifications',
    'header.language': 'Langue',

    'page.dashboardTitle': 'Tableau de bord général',
    'page.dashboardSub': 'matériels et connexions, mode direct',
    'page.inventoryTitle': 'Gestion des stocks',
    'page.inventorySub': 'Matériels de ligne dans tous les entrepôts',
    'page.requisitionsTitle': 'Circuit des réquisitions',
    'page.requisitionsSub': 'Circuit de validation, de l\'examen du consultant à la libération du stock',
    'page.connectionsTitle': 'Tableau de bord de l\'électrification',
    'page.connectionsSub': 'Suivi des programmes en Afrique de l\'Ouest',
    'page.geoMapTitle': 'Application cartographique SIG',
    'page.geoMapSub': 'Couches géospatiales pour',

    'kpi.totalMaterials': 'Total matériels de ligne',
    'kpi.activeRequisitions': 'Réquisitions actives',
    'kpi.pendingApprovals': 'Approbations DG en attente',
    'kpi.trackedConnections': 'Connexions suivies',
    'kpi.deltaQuarter': '3,2 % vs trimestre précédent',
    'kpi.deltaFewer': '8 de moins que la semaine dernière',
    'kpi.deltaUrgent': 'Urgent, action requise',
    'kpi.deltaThisMonth': 'ce mois-ci',
    'kpi.urgentBadge': 'URGENT',

    'status.in_stock': 'En stock',
    'status.low_stock': 'Stock faible',
    'status.out_of_stock': 'Rupture de stock',
    'status.pending_approval': 'En attente d\'approbation',
    'status.director_approved': 'Approuvé par le Directeur',
    'status.released': 'Libéré',

    'priority.urgent': 'Urgent',
    'priority.high': 'Élevée',
    'priority.normal': 'Normale',
    'priority.low': 'Faible',

    'stage.consultant_review': 'Examen du consultant',
    'stage.signed_hardcopy': 'Copie signée',
    'stage.chief_director_approval': 'Approbation du Directeur Général',
    'stage.main_stock_release': 'Libération du stock principal',
    'stage.short.consultant_review': 'Examen',
    'stage.short.signed_hardcopy': 'Copie',
    'stage.short.chief_director_approval': 'Approbation DG',
    'stage.short.main_stock_release': 'Libéré',

    'table.itemCode': 'Code article',
    'table.description': 'Désignation',
    'table.category': 'Catégorie',
    'table.warehouse': 'Entrepôt',
    'table.quantity': 'Quantité',
    'table.unit': 'Unité',
    'table.reorderLevel': 'Seuil de réappro.',
    'table.status': 'Statut',
    'table.lastUpdated': 'Dernière mise à jour',
    'table.requisitionId': 'N° de réquisition',
    'table.contractor': 'Entreprise',
    'table.department': 'Département',
    'table.region': 'Région',
    'table.item': 'Article',
    'table.qtyRequested': 'Qté demandée',
    'table.stage': 'Étape',
    'table.priority': 'Priorité',
    'table.hardcopyRef': 'Réf. copie papier',
    'table.submitted': 'Soumise le',
    'table.approved': 'Approuvée le',
    'table.releasedDate': 'Libérée le',
    'table.country': 'Pays',
    'table.program': 'Programme',
    'table.utility': 'Société d\'électricité',
    'table.accessPercent': 'Taux d\'accès',
    'table.progressToTarget': 'Progression vers l\'objectif',
    'table.households': 'Ménages suivis',
    'table.newThisMonth': 'Nouveaux ce mois-ci',

    'filter.allWarehouses': 'Tous les entrepôts',
    'filter.allStatus': 'Tous les statuts',
    'filter.allStages': 'Toutes les étapes',
    'filter.allPriorities': 'Toutes les priorités',

    'action.export': 'Exporter',
    'action.viewAll': 'Voir tout',
    'action.requestAccess': 'Demander l\'accès à la carte',
    'action.live': 'En direct',
    'action.lastRefreshed': 'Dernière actualisation des données',

    'section.recentRequisitions': 'Réquisitions récentes',
    'section.recentRequisitionsSub': 'Les 5 dernières réquisitions, tous entrepôts confondus',
    'section.waepAccess': 'Accès à l\'électrification',
    'section.waepAccessSub': 'Taux d\'accès vs objectif de 100 % par pays',
    'section.monthlyRollout': 'Déploiement mensuel des connexions',
    'section.monthlyRolloutSub': 'Nouvelles connexions par mois et cumul',
    'section.countrySummary': 'Résumé des programmes par pays',

    'common.Units': 'Unités',
    'common.Metres': 'Mètres',
    'common.Sets': 'Jeux',
    'common.noResults': 'Aucun résultat trouvé',
    'common.showing': 'Affichage de',
    'common.of': 'sur',
    'common.results': 'résultats',
    'common.urgentPending': 'réquisitions urgentes en attente d\'approbation du Directeur Général',

    'category.Transformers': 'Transformateurs',
    'category.Cables': 'Câbles',
    'category.Meters': 'Compteurs',
    'category.Conductors': 'Conducteurs',
    'category.Grounding': 'Mise à la terre',

    'material.DT-100KVA': 'Transformateur de distribution 100 KVA',
    'material.DT-315KVA': 'Transformateur de distribution 315 KVA',
    'material.DT-500KVA': 'Transformateur de distribution 500 KVA',
    'material.LVC-25MM': 'Câble BT 25mm2 armé',
    'material.LVC-70MM': 'Câble BT 70mm2 armé',
    'material.PPM-STS': 'Compteur prépayé STS monophasé',
    'material.PPM-3PH': 'Compteur prépayé triphasé commercial',
    'material.ACSR-Dog': 'Conducteur ACSR Dog',
    'material.ACSR-Rabbit': 'Conducteur ACSR Rabbit',
    'material.GRD-ROD-16': 'Piquet de terre 16mm cuivré',
    'material.GRD-ROD-20': 'Piquet de terre 20mm cuivré',
    'material.SVC-DROP': 'Câble de branchement 16mm2',

    'map.heatmap': 'Carte de chaleur de l\'électrification PEPT',
    'map.heatmapSub': 'Vue pondérée des taux de raccordement des ménages par district',
    'map.facilities': 'Écoles et hôpitaux non électrifiés',
    'map.facilitiesSub': 'Couche de points des établissements publics non raccordés',
    'map.substations': 'Postes et infrastructures du réseau',
    'map.substationsSub': 'Postes 33 kV et 11 kV, couloirs de transport et départs',
    'map.fieldSites': 'Sites de chantier des entreprises',
    'map.fieldSitesSub': 'Sites de projet actifs liés aux réquisitions',
    'map.boundaries': 'Limites administratives',
    'map.boundariesSub': 'Limites des États membres, districts et zones de concession',
    'map.ready': 'Couche prête',
    'map.inDevelopment': 'En développement',
    'map.planned': 'Planifiée',
    'map.comingSoon': 'Carte interactive à venir',

    'toast.countrySwitched': 'Basculé vers {name}, {utility}',
    'toast.languageSwitched': 'Langue de l\'interface définie sur le français',
    'toast.exported': 'Export lancé',

    'nav.reconciliation': 'Rapprochement',
    'page.reconTitle': 'Rapprochement des matériels',
    'page.reconSub': 'Matériels livrés au regard des connexions observées',
    'recon.materialsReleased': 'Matériels livrés',
    'recon.expected': 'Connexions attendues',
    'recon.observed': 'Connexions observées',
    'recon.verified': 'Vérifiées',
    'recon.netVariance': 'Écart net',
    'recon.variance': 'Écart',
    'recon.confidence': 'Fiabilité',
    'recon.releasedUnits': 'Unités livrées',
    'recon.connections': 'Connexions',
    'recon.modelControls': 'Paramètres du modèle',
    'recon.perUnit': 'connexions par unité',
    'recon.commissioningLag': 'Délai de mise en service',
    'recon.days': 'jours',
    'recon.resetDefaults': 'Rétablir les valeurs par défaut',
    'recon.inFlight': 'livraisons encore dans le délai',
    'recon.holdApplied': 'Blocage d\'approbation appliqué',
    'recon.holdBanner': 'entreprises en blocage d\'approbation',
    'recon.onHold': 'Bloquée',
    'recon.noFlags': 'Aucune entreprise hors tolérance',
    'recon.blendMath': 'Construction de cette estimation',
    'recon.lineItems': 'Livraisons prises en compte',
    'recon.ratioApplied': 'Ratio',
    'recon.contribution': 'Apport',
    'status.on_track': 'Conforme',
    'status.watch': 'À surveiller',
    'status.investigate': 'À investiguer',
    'status.over_reported': 'Surdéclaré',
    'confidence.high': 'Élevée',
    'confidence.medium': 'Moyenne',
    'confidence.low': 'Faible',

    'mtf.viewRate': 'Taux de connexion',
    'mtf.viewTier': "Niveau d'accès",
    'mtf.rateSub': "Taux d'accès actuel vs objectif universel de 100 %",
    'mtf.tierSub': 'Part de la population par niveau de service, niveau 0 à niveau 5',
    'mtf.disclaimer': 'Adaptation simplifiée du cadre multi-niveaux ESMAP de la Banque mondiale',
    'tier.0': 'Aucun accès',
    'tier.1': 'Très limité',
    'tier.2': 'Limité',
    'tier.3': 'Modéré',
    'tier.4': 'Élevé',
    'tier.5': 'Très élevé',
    'attribute.capacity': 'Capacité',
    'attribute.duration': 'Durée',
    'attribute.reliability': 'Fiabilité',
    'attribute.affordability': 'Accessibilité financière',
    'table.modalTier': 'Niveau type',
  },
};

export function translate(
  lang: Language,
  key: string,
  vars?: Record<string, string | number>
): string {
  let result = dictionary[lang][key] ?? dictionary.en[key] ?? key;
  if (vars) {
    Object.entries(vars).forEach(([k, v]) => {
      result = result.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
    });
  }
  return result;
}

export function formatNumber(value: number, lang: Language): string {
  return value.toLocaleString(lang === 'fr' ? 'fr-FR' : 'en-US');
}

export function formatDate(iso: string, lang: Language): string {
  const [year, month, day] = iso.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  return new Intl.DateTimeFormat(lang === 'fr' ? 'fr-FR' : 'en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date);
}
